<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<!--
				<label class="header collapse-link" data-bs-toggle="collapse" href="#filerCollapseStatus">Status <i class="fas fa-caret-down"></i></label>
				<div class="collapse" id="filerCollapseStatus">
					<div class="form-check" *ngFor="let item of status; index as itemId;">
						<input type="checkbox" class="form-check-input" id="checkbox_{{ item.id }}" [checked]="filters.status[itemId]" [(ngModel)]="filters.status[itemId]">
						<label class="form-check-label" for="checkbox_{{ item.id }}">{{ item.name }}</label>
					</div>
				</div>
				<div class="mb-3 row">
					<label class="col-sm-3 col-form-label" for="licenseForCompany">Licencja dla firmy</label>
					<select data-bs-live-search="true" class="form-control col-sm-9" id="licenseForCompany" [(ngModel)]="filters.licenseForCompany" name="licenseForCompany">
						<option value="">(wszystko)</option>
						<option value="-1">(brak)</option>
						<option value="{{ item.id }}" *ngFor="let item of companies">{{ item.name }}</option>
					</select>
				</div>
-->
				<label for="status" class="mt-3">Status</label>
				<ng-select
					class="mb-5"
					id="vehicle_status"
					name="vehicle_status"
					[(ngModel)]="filters.vehicle_status"
					[multiple]="true"
					[closeOnSelect]="false"
				>
					<ng-option *ngFor="let item of parameters.vehicle_status" [value]="item.id">{{
						item.name
					}}</ng-option>
				</ng-select>
			</div>
			<div class="modal-footer">
				<div class="row row-full">
					<div class="col-sm-4">
						<button type="button" class="btn btn-secondary" (click)="filtersClear()">Wyczyść filtry</button>
					</div>
					<div class="col-sm-8 text-end">
						<button type="button" class="btn btn-primary me-2" (click)="filtersSave()">Pokaż</button>
						<button
							type="button"
							class="btn btn-secondary"
							(click)="filtersClose()"
							data-bs-dismiss="modal"
						>
							Anuluj
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
